import {Component, OnInit, OnDestroy, Inject, PLATFORM_ID} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FooterService } from '../../Services/footer/footer.service';
import { LangService } from '../../Services/lang/lang.service';
import { AnalyticsService } from '../../Services/analytics/analytics.service';
import { Router, NavigationExtras, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  public showSlaask;
  public showFooter;
  private footerSlackSubscriber;
  private footerVisibilitySubscriber;
  private langSubscriber;
  private routeSubscriber;
  public o2Url;
  public currentLang;

  constructor(public translate: TranslateService,
    private footer: FooterService,
    private langService: LangService,
    private analytics: AnalyticsService,
    private route: Router,
    @Inject(PLATFORM_ID) private platform: Object) { }


  ngOnInit() {
    this.footerSlackSubscriber = this.footer.ss.subscribe(res => {
      this.showSlaask = res;
    });
    this.footerVisibilitySubscriber = this.footer.sf.subscribe(res => {
      this.showFooter = res;
    });
    this.langSubscriber = this.langService.cl.subscribe(res => {
      this.currentLang = res;
    });
      if (isPlatformBrowser(this.platform)) {
          this.routeSubscriber = this.route.events.subscribe((event: any) => {
              if (event instanceof NavigationEnd) {
                  this.o2Url = event.url.indexOf('partners/o2priority') > -1;
              }
          });
      }
  }

  socialLinksEvents(social) {
    switch (social) {
      case 'facebook':
        this.analytics.logEvent('facebook');
        break;
      case 'twitter':
        this.analytics.logEvent('twitter');
        break;
      case 'instagram':
        this.analytics.logEvent('instagram');
        break;
      case 'snapchat':
        this.analytics.logEvent('snapchat');
        break;
      default:
        break;
    }
  }

  ngOnDestroy(): void {
    if (this.footerSlackSubscriber) {
      this.footerSlackSubscriber.unsubscribe();
    }
    if (this.footerVisibilitySubscriber) {
      this.footerVisibilitySubscriber.unsubscribe();
    }
    if (this.langSubscriber) {
      this.langSubscriber.unsubscribe();
    }
    if (this.routeSubscriber) {
        this.routeSubscriber.unsubscribe();
    }
  }

  actionTrigger(action) {
    if (action === 'logo') {
      this.analytics.logEvent('footer_logo');
    }
    if (action === 'picks') {
      this.analytics.logEvent('footer_our_picks');
    }
    if (action === 'reviews') {
      this.analytics.logEvent('footer_review');
    }
    if (action === 'giftcard') {
      this.analytics.logEvent('footer_gift_cards');
    }
    if (action === 'partners') {
      this.analytics.logEvent('footer_partnerships');
    }
    if (action === 'contact') {
      this.analytics.logEvent('footer_contact');
    }
    if (action === 'terms') {
      this.analytics.logEvent('footer_terms');
    }
    if (action === 'privacy') {
      this.analytics.logEvent('footer_privacy');
    }
    if (action === 'ios') {
      this.analytics.logEvent('footer_app_ios');
      this.analytics.logEvent('appstore_link');
    }
    if (action === 'android') {
      this.analytics.logEvent('footer_app_android');
      this.analytics.logEvent('playstore_link');
    }
  }

  mainSiteURL() {
    return environment.metaUrl;
  }
}
